import { useHistory } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton"
import Footer from "../../components/Footer/Footer"
import NavHeaders from "../../components/NavHeaders/NavHeaders"
import OrderDetails from "../../components/OrderDetails/OrderDetails";
import './Profile.css';
import {useState, useEffect} from 'react';

const Profile = () => {

    const history = useHistory();
    const isLoggedIn = localStorage.getItem("sessionId");
    const sessionId = localStorage.getItem("sessionId");
    const userId = localStorage.getItem("userId");

    const [orderDetailsData, setOrderDetailsData] = useState([]);   
    const [ordersLoading, setOrderLoading] = useState(false); 
    const handleChatRoomClick = () => {
        window.open("https://citcet-app.herokuapp.com/room.html?userId="+userId, "_blank");
    }
    
    const logInBtnHandler = () => {
        history.push("/login");
    }

    const getOrderDetails = async () => {
        const orderDetails = await fetch('https://backend-markopedia.herokuapp.com/api/order', {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + sessionId
            }
        }).then(res => res.json());
        console.log(orderDetails)
        setOrderDetailsData(orderDetails.data);
        setOrderLoading(true)
    }

    useEffect(() => {
        getOrderDetails();
    }, [])

    return (
        <>
            <NavHeaders />
            <div className="gap-section"></div>
            <BackButton text="Back to Home" goBack="home"/>
            {
                isLoggedIn ? 
                <div className="profile-content-wrapper">
                <div className="profile-content-header">
                    <h2 className="transaction-title">Transaksi saya</h2>
                    <h4 onClick={handleChatRoomClick}>See my chat room</h4>
                </div>
                {
                    ordersLoading ?
                    <div className="profile-content-body">
                    <table>
                        <tr className="content-body-header">
                            <th>Nama produk</th>
                            <th>Tanggal</th>
                            <th>Jumlah</th>
                            <th>Harga (Rp)</th>
                            <th>Status</th>
                        </tr>
                        {
                            orderDetailsData.map(x => {
                                return <OrderDetails
                                    productName={x.productName}
                                    date={x.orderTime}
                                    price={x.price}
                                    status={x.statusUrl}
                                />
                            })
                        }
                    </table>
                    </div>
                    :
                    <div className="loader-wrapper">
                        <div className="loader"></div>
                    </div>
                }
                </div>
                :
                <div className="profile-notloggedin-wrapper">
                    <div>
                        <h1><span onClick={logInBtnHandler} className="profile-notloggedin-loginbtn">Log in </span>untuk melihat profil Anda.</h1>
                    </div>
                </div>
            }
            <Footer />
        </>
    )
}

export default Profile;